import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { COMMON_API } from "../../commonAPI";

const AddLoanEffortless = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loanIdFromState = location.state?.loan_id || "";

  const token = sessionStorage.getItem("authToken");
  const [loans, setLoans] = useState([]);
  const [selectedLoanId, setSelectedLoanId] = useState(loanIdFromState);
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);

  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/allLoans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.loan || []);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedLoanId || !description.trim() || !image) {
      alert("Loan, description and image are required");
      return;
    }

    const formData = new FormData();
    formData.append("loan_id", selectedLoanId);
    formData.append("description", description);
    formData.append("image", image);

    try {
      await axios.post(`${COMMON_API}/loan/addLoanEffortless`, formData, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });
      navigate(-1);
    } catch (error) {
      console.error("Error adding effortless:", error);
    }
  };

  useEffect(() => {
    fetchLoans();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">Add Loan Effortless</h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Loan select */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Select Loan</label>
            <select
              value={selectedLoanId}
              onChange={(e) => setSelectedLoanId(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">-- Select Loan --</option>
              {loans.map((loan) => (
                <option key={loan.id} value={loan.id}>
                  {loan.name}
                </option>
              ))}
            </select>
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Description</label>
            <textarea
              rows="4"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description..."
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Image upload */}
          <div>
            <label className="block text-gray-600 font-medium mb-1">Upload Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files[0])}
              className="w-full"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Add Effortless
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddLoanEffortless;
